import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import '../../styles/pages/auth-improvements.css';

export default function PasswordRecovery(){
 const [token,setToken]=useState(()=>window.location.hash.slice(1));
 const [email,setEmail]=useState(''),[password,setPassword]=useState(''),[confirm,setConfirm]=useState('');
 const [busy,setBusy]=useState(false),[message,setMessage]=useState(''),[error,setError]=useState(''),[done,setDone]=useState(false);
 const {logout}=useAuth();
 useEffect(()=>{
  const receiveLink=()=>{
   const incoming=window.location.hash.slice(1);if(!incoming)return;
   setToken(incoming);setDone(false);setMessage('');setError('');setPassword('');setConfirm('');
   window.history.replaceState(window.history.state,'',window.location.pathname+window.location.search);
  };
  receiveLink();window.addEventListener('hashchange',receiveLink);
  return()=>window.removeEventListener('hashchange',receiveLink);
 },[]);
 async function submit(e){e.preventDefault();setError('');
  if(token&&(password!==confirm||password.length<12)){setError('Brug mindst 12 tegn, og gentag den samme adgangskode.');return;}
  setBusy(true);try{
   if(token){await api.auth.resetPassword({token,newPassword:password});await logout();setPassword('');setConfirm('');setMessage('Din adgangskode er ændret. Log ind igen; to-faktorbekræftelse gælder fortsat, hvis den er aktiveret.');}
   else {await api.auth.forgotPassword(email);setMessage('Hvis kontoen kan gendannes, modtager du et link til at vælge en ny adgangskode. Linket gælder i 30 minutter.');}
   setDone(true);
  }catch{setError(token?'Linket er ugyldigt, udløbet eller brugt, eller adgangskoden er for lang. Brug 12 tegn eller flere og højst 72 UTF-8-bytes. Du kan anmode om et nyt link.':'Anmodningen kunne ikke gennemføres. Vent lidt, og prøv igen.');}
  finally{setBusy(false);}
 }
 return <div className="auth-container auth-login-compact"><div className="auth-main-content"><div className="auth-form">
  <div className="auth-form-header"><h2>{token?'Vælg ny adgangskode':'Glemt adgangskode'}</h2></div>
  {message&&<p role="status" className="info">{message}</p>}{error&&<p role="alert" className="error">{error}</p>}
  {!done&&<form onSubmit={submit}>
   {token?<><div className="form-group"><label htmlFor="reset-new">Ny adgangskode</label><input id="reset-new" type="password" autoComplete="new-password" minLength={12} required value={password} onChange={e=>setPassword(e.target.value)}/></div>
   <div className="form-group"><label htmlFor="reset-confirm">Gentag adgangskode</label><input id="reset-confirm" type="password" autoComplete="new-password" minLength={12} required value={confirm} onChange={e=>setConfirm(e.target.value)}/></div></>:
   <div className="form-group"><label htmlFor="reset-email">E-mail</label><input id="reset-email" type="email" autoComplete="email" required value={email} onChange={e=>setEmail(e.target.value)}/></div>}
   <button className="btn primary" type="submit" disabled={busy}>{busy?'Vent…':token?'Gem ny adgangskode':'Send gendannelseslink'}</button>
  </form>}
  {token&&error&&<p><a href="/reset-password">Anmod om nyt link</a></p>}<p><Link to="/login">Tilbage til login</Link></p>
 </div></div></div>;
}
